import React, { useEffect, useState } from "react";
import { colorBackground, colorHover } from "@/utils/palette";
import { marginRight, right, left } from "@/utils/directions";
import styled from "styled-components";
import {
  colorBlue,
  colorStatusActive,
  colorTextNew,
} from "../../../../../utils/palette";
import { TopbarBack } from "../../../../../containers/Layout/components/topbar/BasicTopbarComponents";
import { Button } from "../../../Button";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  getCsvData,
  getCsvDataV2,
  getFormattedOffset,
  getPdfData,
  getPdfDataV2,
  getWODataForPdf,
  post,
  postApi,
  putApi,
} from "../../../../../api/getUser";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useLocation } from "react-router";
import { getCsvPdfData } from "../../../../constants/defaultColumns";
import { ColumnReOrderButtonContainer } from "../ColumnReorder";
import { Icon } from "../../../TableElements";
import { CSVLink } from "react-csv";
import { NATEXT, providerNameMapping } from "../../../../constants";
import {
  daysHoursMinutes,
  getDisplayDate,
  getDistanceUnit,
  getListingDisplayDate,
  getScreenName,
} from "../../../../helpers";
import {
  dhm,
  getTimeSinceAcceptance,
} from "../../../../../components/WorkOrders";
import SubscribePopup from "../../../SubscribePopup";
import { useAuth } from "../../../../../contexts/AuthContext";
import SubscribeTooltipIcon from "../../../SubscribeTooltipIcon";
import addDays from "date-fns/addDays";
import format from "date-fns/format";
import { addSnackbarData } from "../../../../../features/snackbar/snackbarSlice";
import { useDispatch } from "react-redux";
import getUnixTime from "date-fns/getUnixTime";
import InfoPopup from "../../../InfoPopup";
import ImportNewVehiclesPopup from "../../../../../components/Settings/Integrations/components/ImportNewVehiclesPopup";
import { getIssuePriorityText } from "../../../../../components/Issues/IssuesTable.jsx";
//import Loading, { LoadIcon } from "../../../Loading";

const MoreOptions = ({
  screen,
  columnOrder,
  rows,
  setShowImportPopup,
  setImportScreenName,
}) => {
  let screenName = getScreenName(screen);
  // if (screenName === "renewals") {
  //   screenName = "maintenancereminders";
  // }
  // if (screenName === "service" || screenName === "expense") {
  //   screenName += "s";
  // }
  if (screenName === "work_order") {
    screenName = "workorders";
  }

  const columns = useSelector((state) => state.advancedFilter[screenName]);

  const [toggleOptions, setToggleOptions] = useState(false);

  //New vehicles to be added
  const [vehicles, setVehicles] = useState([]);
  const [showImportVehiclesPopup, setShowImportVehiclesPopup] = useState(false);

  const location = useLocation();
  const { roleId } = useSelector((state) => state.user);
  const { isViewOnly, integrationsData } = useAuth();

  const modulesForImportList = [
    "users",
    "vehicles",
    "service",
    "expense",
    "servicetasks",
    "expensetasks",
    "inspectiontasks",
    "inspectionforms",
    "dailymileage",
    "fillups",
    "maintenancereminders",
    "renewals",
    "trips",
    "parts",
    "equipment",
  ];

  const modulesForCsvPdfList = [
    "dailytimesheet",
    "users",
    "vehicles",
    "dailymileage",
    "fillups",
    "service",
    "expense",
    "trips",
    "issues",
    "work_order",
    "maintenancereminders",
    "renewals",
    "inspectionschedules",
    "inspectionsubmissions",
    "parts",
    "usage",
    "documentrenewals",
    "equipment",
  ];

  const currentModule = getScreenName(location.pathname);
  const hasImport =
    modulesForImportList.includes(currentModule) && roleId != 4 && !isViewOnly;
  const hasCsvPdf = modulesForCsvPdfList.includes(currentModule);
  const hasTelematicsSync =
    screen?.includes("vehicles") &&
    integrationsData?.find((i) => i?.provider_type === 1) &&
    roleId === 1;
  if (!hasImport && !hasCsvPdf && !hasTelematicsSync) {
    return null;
  }

  const handleClick = (e) => {
    e.preventDefault();
    setToggleOptions(!toggleOptions);
  };

  return (
    <div>
      <ColumnReOrderButtonContainer
        id={`more-options-btn-${screen}`}
        data-testid={`${getScreenName(screen)}-more-options-btn`}
        variant="outline-secondary"
        size="sm"
        onClick={handleClick}
      >
        {/* <MoreVertIcon /> */}
        {/* <MenuIcon fill='35353B' /> */}
        <Icon className="fi fi-rr-menu-dots-vertical"></Icon>
      </ColumnReOrderButtonContainer>
      {toggleOptions && (
        <TopbarBack
          type="button"
          aria-label="profile button"
          onClick={() => setToggleOptions(!toggleOptions)}
        />
      )}
      {toggleOptions && (
        <OptionsMenus
          columns={columns}
          screen={screen}
          columnOrder={columnOrder}
          rows={rows}
          setShowImportPopup={setShowImportPopup}
          setToggleOptions={setToggleOptions}
          //showImportVehiclesPopup={showImportVehiclesPopup}
          setShowImportVehiclesPopup={setShowImportVehiclesPopup}
          //vehicles={vehicles}
          setVehicles={setVehicles}
          screenName={screenName}
          setImportScreenName={setImportScreenName}
        />
      )}
      {showImportVehiclesPopup && (
        <ImportNewVehiclesPopup
          showPopup={showImportVehiclesPopup}
          setShowPopup={setShowImportVehiclesPopup}
          vehicles={vehicles}
          setVehicles={setVehicles}
        />
      )}
    </div>
  );
};

export default MoreOptions;

const OptionsMenus = ({
  columns,
  screen,
  columnOrder,
  rows,
  setShowImportPopup,
  setToggleOptions,
  //vehicles,
  setVehicles,
  //showImportVehiclesPopup,
  setShowImportVehiclesPopup,
  screenName,
  setImportScreenName
}) => {
  const dispatch = useDispatch();
  const direction = useSelector((state) => state.direction.direction);

  //const groupsList = useSelector((state) => state.groups.list);
  const usersList = useSelector((state) => state.users.list);
  const { distance, currency } = useSelector((state) => state.units);
  const myColumns = { ...columns };
  let colOrder = useSelector((state) => state.columns.order);
  const location = useLocation();
  const path = location.pathname;
  const [loading, setLoading] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const { t } = useTranslation("common");
  const { userName, roleId } = useSelector((state) => state.user);
  const { tag, integrationsData, setReload, isViewOnly } = useAuth();
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [subscribeMsg, setSubscribeMsg] = useState(t("subscribe_msg"));

  const [showNewVehiclesAddedPopup, setShowNewVehiclesAddedPopup] =
    useState(false);
  const [newVehiclesAddedData, setNewVehiclesAddedData] = useState({
    message: "",
    icon: { className: "fi fi-rr-cross-circle", color: "red" },
  });

  const [newVehiclesLoading, setNewVehiclesLoading] = useState(false);

  //Hide fetch new vehicles option for jimilab user
  const [jimilabUser, setJimilabUser] = useState(false);
  const integrationsPresent = integrationsData?.find(
    (integration) => integration?.provider_type === 1,
  );

  //For pdf and csv generated on the client side (Screens - User Management, Vehicles)
  const [csvData, setCsvData] = useState("");
  const [pdfData, setPdfData] = useState("");

  const moduleName = getScreenName(path);
  const modulesForImport = [
    "users",
    "vehicles",
    "service",
    "expense",
    "servicetasks",
    "expensetasks",
    "inspectiontasks",
    "inspectionforms",
    "dailymileage",
    "fillups",
    "maintenancereminders",
    "renewals",
    "trips",
    "parts",
    "equipment",
  ];

  const modulesForCsvPdf = [
    "dailytimesheet",
    "users",
    "vehicles",
    "dailymileage",
    "fillups",
    "service",
    "expense",
    "trips",
    "issues",
    "work_order",
    "maintenancereminders",
    "renewals",
    "inspectionschedules",
    "inspectionsubmissions",
    "parts",
    "usage",
    "documentrenewals",
    "equipment",
  ];

  const { pdfHeader, defaultColumns, pdfFileName } = getCsvPdfData();

  const provider = integrationsData[0]?.provider;
  const providerName = providerNameMapping[provider];

  //effect to set jimilabUser to hide fetch new vehicles option
  useEffect(() => {
    if (integrationsData?.length > 0 && integrationsData[0]?.provider === 5) {
      setJimilabUser(true);
    }
  }, [integrationsData]);

  //Effect to set CSV and PDF Data for Client Side Fetching Screens
  useEffect(() => {
    if (
      screen.includes("users") ||
      //screen.includes("vehicles") ||
      screen.includes("dailytimesheet") ||
      screen.includes("inspectionscheduling")
    ) {
      if (columnOrder?.length > 0) {
        const orderLimit = Number(Object.keys(defaultColumns).slice(-1));
        // const colOrderLimit = screen.includes("vehicles")
        //   ? +orderLimit
        //   : +orderLimit + 1;
        const colOrderLimit = +orderLimit + 1;

        let selectedColumns = colOrder
          .map((c) => +c - 1)
          .filter((col) => +col <= colOrderLimit);

        //Columns in listing is 5 but in pdf, csv is 6 - Hence setting manually
        if (screen?.includes("inspectionscheduling")) {
          selectedColumns = [0, 1, 2, 3, 4, 5, 6];
        }

        let tempCsvArr = [];
        let tempPdfArr = [];
        rows?.forEach((row) => {
          let tempCsvObj = {};
          let tempPdfObj = {};

          //Logic to set csv and pdf objs for users
          if (screen.includes("users")) {
            selectedColumns.forEach((no) => {
              const currentCol = defaultColumns[no];
              if (currentCol) {
                const { accessor, header } = currentCol;
                if (accessor === "user_active") {
                  tempCsvObj[header] =
                    row.original[accessor] === 1 ? t("active") : t("inactive");

                  tempPdfObj[accessor] =
                    row.original[accessor] === 1 ? t("active") : t("inactive");
                } else if (accessor === "joining_date") {
                  let joiningDate = row.original[accessor]
                    ? getListingDisplayDate(row.original[accessor])
                    : NATEXT;

                  tempCsvObj[header] = joiningDate;
                  tempPdfObj[accessor] = joiningDate;
                } else {
                  tempCsvObj[header] = row.original[accessor]
                    ? row.original[accessor]
                    : NATEXT;

                  tempPdfObj[accessor] = row.original[accessor]
                    ? row.original[accessor]
                    : NATEXT;
                }
              }
            });
          }

          //Logic to set csv and pdf objs for vehicles
          // if (screen.includes("vehicles")) {
          //   selectedColumns.forEach((no) => {
          //     const currentCol = defaultColumns[no];
          //     const { accessor, header } = currentCol;
          //     if (accessor === "veh_active") {
          //       let vehicleStatus = NATEXT;
          //       if (row.original[accessor] == 1) {
          //         vehicleStatus = t("active");
          //       } else {
          //         vehicleStatus = t("inactive");
          //       }

          //       tempCsvObj[header] = vehicleStatus;
          //       tempPdfObj[accessor] = vehicleStatus;
          //     } else if (accessor === "operational_status") {
          //       const { veh_active, secondary_status } = row.original;
          //       let secondaryStatus = t("in_service");

          //       if (veh_active === 1 && secondary_status === 1) {
          //         secondaryStatus = t("out_of_service");
          //       }

          //       if (veh_active === 0 || veh_active === 2) {
          //         secondaryStatus = NATEXT;
          //       }

          //       // if (veh_active === 0 && secondary_status === 2) {
          //       //   secondaryStatus = t("unconfirmed");
          //       // }

          //       tempCsvObj[header] = secondaryStatus;
          //       tempPdfObj[accessor] = secondaryStatus;
          //     } else if (accessor === "group_id") {
          //       let selectedGroup = NATEXT;
          //       if (row.original[accessor]) {
          //         selectedGroup = groupsList.find(
          //           (g) => g.group_id === row.original[accessor]
          //         )?.group_name;
          //       }
          //       tempCsvObj[header] = selectedGroup;
          //       tempPdfObj[accessor] = selectedGroup;
          //     } else if (accessor === "odo") {
          //       let currentOdo = NATEXT;
          //       //No odo unit in csv
          //       let currentOdoVal = NATEXT;
          //       if (row.original[accessor]) {
          //         let distanceUnit = getDistanceUnit(distance);
          //         currentOdo = `${row.original[accessor]} ${distanceUnit}`;
          //         currentOdoVal = row.original[accessor];
          //       }
          //       tempCsvObj[header] = currentOdoVal;
          //       tempPdfObj[accessor] = currentOdo;
          //     } else {
          //       tempCsvObj[header] = row.original[accessor]
          //         ? row.original[accessor]
          //         : NATEXT;

          //       tempPdfObj[accessor] = row.original[accessor]
          //         ? row.original[accessor]
          //         : NATEXT;
          //     }
          //   });
          // }

          //Logic to set csv and pdf objs for daily time sheet
          if (screen.includes("dailytimesheet")) {
            selectedColumns.forEach((no) => {
              const currentCol = defaultColumns[no];
              const { accessor, header } = currentCol;
              if (accessor === "timesheet_date") {
                let displayDate = getDisplayDate(row.original[accessor]);
                tempCsvObj[header] = displayDate;
                tempPdfObj[accessor] = displayDate;
              } else {
                tempCsvObj[header] = row.original[accessor]
                  ? row.original[accessor]
                  : NATEXT;

                tempPdfObj[accessor] = row.original[accessor]
                  ? row.original[accessor]
                  : NATEXT;
              }
            });
          }

          //Logic to set csv and pdf objs for inspection schedule
          if (screen.includes("inspectionscheduling")) {
            const distanceUnit =
              row.original.primary_meter === "Hours"
                ? getDistanceUnit("Hours")
                : getDistanceUnit(distance);
            selectedColumns.forEach((no) => {
              const currentCol = defaultColumns[no];
              const { accessor, header } = currentCol;
              //Status
              if (accessor === "status") {
                const { percentage } = row.original;
                let status = t("scheduled_caps");
                let color = "#5CB85C";
                if (percentage <= 90) {
                  status = t("scheduled_caps");
                  color = "#5CB85C";
                } else if (percentage > 90 && percentage < 100) {
                  status = t("due_soon_caps");
                  color = "#F0AD4E";
                } else if (percentage >= 100) {
                  status = t("overdue_caps");
                  color = "#D9534F";
                }
                tempCsvObj[header] = status;
                tempPdfObj[accessor] = status;
              } else if (accessor === "due_in") {
                //dueInDays
                let dueInDays = 0;
                const { due_days, last_inspection_date } = row.original;
                if (due_days) {
                  let due = last_inspection_date + Number(due_days) * 86400;
                  const currentDate = getUnixTime(new Date());
                  dueInDays =
                    ((due - currentDate) / (60 * 60 * 24)).toFixed(0) || 0;
                }

                let maxOdo = row.original.maxOdo || 0;
                //dueInOdo
                const dueInOdo =
                  +row.original.last_inspection_odo && +row.original.due_odo
                    ? (
                        +row.original.last_inspection_odo +
                        +row.original.due_odo -
                        +maxOdo
                      )?.toFixed(2)
                    : 0;

                //dueInText
                let dueIn = NATEXT;
                if (+row.original.percentage < 100) {
                  if (dueInDays && +dueInOdo > 0) {
                    dueIn = `${dueInOdo} ${distanceUnit} ${t(
                      "or",
                    )} ${dueInDays} ${t("days_sm_other")}`;
                  } else if (!dueInDays && +dueInOdo > 0) {
                    dueIn = `${dueInOdo} ${distanceUnit}`;
                  } else if (dueInDays && +dueInOdo <= 0) {
                    dueIn = `${dueInDays} ${t("days_sm_other")}`;
                  }
                }
                tempCsvObj[header] = dueIn;
                tempPdfObj[accessor] = dueIn;
              } else if (accessor === "due_on") {
                //dueOnDate
                let dueOnDate = 0;
                const { last_inspection_date, due_days } = row.original;
                if (due_days) {
                  let lastInspectionDate = new Date(
                    last_inspection_date * 1000,
                  );
                  dueOnDate = new Date(last_inspection_date * 1000);
                  dueOnDate.setDate(lastInspectionDate.getDate() + +due_days);
                }

                //dueOnOdo
                let dueOnOdo = 0;
                const { last_inspection_odo, due_odo } = row.original;
                if (+due_odo) {
                  dueOnOdo = +last_inspection_odo + +due_odo;
                }

                //dueOnText
                let dueOn = NATEXT;
                if (dueOnDate && dueOnOdo) {
                  dueOn = `${dueOnOdo} ${distanceUnit} ${t("or")} ${format(
                    dueOnDate,
                    "yyyy-MM-dd hh:mm:ss",
                  )}`;
                } else if (!dueOnDate && dueOnOdo) {
                  dueOn = `${dueOnOdo} ${distanceUnit}`;
                } else if (dueOnDate && !dueOnOdo) {
                  dueOn = `${format(dueOnDate, "yyyy-MM-dd hh:mm:ss")}`;
                }
                tempCsvObj[header] = dueOn;
                tempPdfObj[accessor] = dueOn;
              } else if (accessor === "last_inspected") {
                const lastInspectedOdo = +row.original.last_inspection_odo
                  ? `${row.original.last_inspection_odo} ${distanceUnit}`
                  : 0;
                const lastInspectedDate = row.original.last_inspection_date
                  ? format(
                      new Date(row.original.last_inspection_date * 1000),
                      "yyyy-MM-dd hh:mm:ss",
                    )
                  : 0;
                let lastInspected = `${lastInspectedOdo} / ${lastInspectedDate}`;
                if (lastInspectedOdo && !lastInspectedDate) {
                  lastInspected = lastInspectedOdo;
                }

                if (!lastInspectedOdo && lastInspectedDate) {
                  lastInspected = lastInspectedDate;
                }

                tempCsvObj[header] = lastInspected;
                tempPdfObj[accessor] = lastInspected;
              } else if (accessor === "schedule_type") {
                const scheduleType = row.original.recurring;
                let scheduleTypeText = "";
                if (scheduleType === 0) {
                  scheduleTypeText = t("one_time");
                } else if (scheduleType === 1) {
                  scheduleTypeText = t("recurring");
                }
                tempCsvObj[header] = scheduleTypeText;
                tempPdfObj[accessor] = scheduleTypeText;
              } else {
                tempCsvObj[header] = row.original[accessor]
                  ? row.original[accessor]
                  : NATEXT;

                tempPdfObj[accessor] = row.original[accessor]
                  ? row.original[accessor]
                  : NATEXT;
              }
            });
          }

          tempCsvArr.push(tempCsvObj);
          tempPdfArr.push(tempPdfObj);
        });
        setCsvData(tempCsvArr);
        setPdfData(tempPdfArr);
      }
    }
  }, [columnOrder, rows]);

  const {
    start_date,
    end_date,
    search,
    order,
    filter_vehicle_id,
    filter_group_id,
    start,
    category_id,
    asset_type,
    filter_asset_type,
  } = useSelector((state) => state.filter.data);
  const searchValue = search.value;
  const orderArray = [order[0].column, order[0].dir];

  const csvApiData = {
    start_date,
    end_date,
    //search: searchValue,
    //order: [orderArray],
    search,
    order,
    filter_vehicle_id,
    filter_group_id,
    category_id,
    asset_type,
    filter_asset_type,
    utc_offset: getFormattedOffset(),
  };

  if (screen.includes("dailymileage")) {
    colOrder = [1, 2, 3, 4, 5, 6, 7, 8];
  }
  if (screen.includes("maintenancereminders") || screen.includes("renewals")) {
    colOrder = [1, 2, 3, 4];
  }
  if (screen.includes("inspectionsubmissions")) {
    colOrder = [1, 2, 3, 4, 5];
  }
  if (
    screen.includes("users") ||
    //screen.includes("vehicles") ||
    screen.includes("dailytimesheet")
  ) {
    colOrder = columnOrder;
  }

  const generateWOData = async () => {
    const apiJson = {
      draw: 1,
      length: 100,
      search: search,
      order: order,
      start_date: start_date,
      end_date: end_date,
      start: start,
      filter_group_id: filter_group_id,
      filter_vehicle_id: filter_vehicle_id,
      querystring: "get_all_workorder_data",
      ...columns,
    };
    const res = await getWODataForPdf(apiJson);
    const { data, pause_data } = res;
    const selectedColumns = colOrder
      .filter((no) => no <= 17)
      .map((c) => +c - 1);

    let tempCsvArr = [];
    let tempPdfArr = [];
    data?.forEach((row) => {
      let tempCsvObj = {};
      let tempPdfObj = {};
      selectedColumns.forEach((no) => {
        const currentCol = defaultColumns[no];
        const { accessor, header } = currentCol;
        if (
          accessor === "created_by"
          //|| accessor === "assigned_to"
        ) {
          let selectedUser = NATEXT;
          if (row[accessor]) {
            selectedUser = usersList.find(
              (g) => g.user_id === row[accessor],
            )?.name;
          }
          tempCsvObj[header] = selectedUser;
          tempPdfObj[accessor] = selectedUser;
        } else if (accessor === "type") {
          let type = row[accessor] == 1 ? t("unscheduled") : t("scheduled");
          tempCsvObj[header] = type;
          tempPdfObj[accessor] = type;
        } else if (accessor === "status") {
          let status = NATEXT;
          if (row[accessor] === "new") {
            status = t("new");
          } else if (row[accessor] == 0) {
            status = t("drawer_open");
          } else if (row[accessor] == 1) {
            status = t("in_progress");
          } else if (row[accessor] == 2) {
            status = t("paused");
          } else if (row[accessor] == 3) {
            status = t("closed");
          }
          tempCsvObj[header] = status;
          tempPdfObj[accessor] = status;
        } else if (accessor === "odo") {
          let odo =
            row[accessor] && row[accessor] != -1000
              ? `${row[accessor]} ${getDistanceUnit(distance)}`
              : NATEXT;
          //No odo unit in csv
          let odoVal = row[accessor];
          tempCsvObj[header] = odoVal && odoVal !== -1000 ? odoVal : NATEXT;
          tempPdfObj[accessor] = odo;
        } else if (accessor === "priority") {
          let priority = t("not_set");

          if (row[accessor] == 0) {
            priority = t("not_set");
          }
          if (row[accessor] == 1) {
            priority = t("low");
          }
          if (row[accessor] == 2) {
            priority = t("med");
          }
          if (row[accessor] == 3) {
            priority = t("high");
          }

          tempCsvObj[header] = priority;
          tempPdfObj[accessor] = priority;
        } else if (accessor === "due_date" || accessor === "create_date") {
          let dateVal = row[accessor] ? getDisplayDate(row[accessor]) : NATEXT;
          tempCsvObj[header] = dateVal;
          tempPdfObj[accessor] = dateVal;
        } else if (accessor === "total_cost") {
          let totalCost = NATEXT;
          const { total } = row;
          totalCost = +total > 0 ? `${total} ${currency}` : NATEXT;
          tempCsvObj[header] = total;
          tempPdfObj[accessor] = totalCost;
        } else if (accessor === "duration") {
          let duration = NATEXT;
          const {
            status,
            technician_id,
            start_date,
            end_date,
            starting_time,
            ending_time,
            working_days,
            wo_id,
            total_time,
          } = row;

          if ((status === 1 || status === 2) && start_date) {
            let pausesForRecord = pause_data?.filter((p) => p.wo_id === wo_id);
            const incompletePause = pausesForRecord?.find((p) => !p.end_time);
            let completedPauses = [];
            if (pausesForRecord?.length > 0) {
              completedPauses = pausesForRecord?.filter((p) => p.end_time);
            }

            // let technician = "";
            // if (technician_id) {
            //   technician = usersList?.find(
            //     (u) => u.user_id === technician_id
            //   );
            // }

            let startTime = new Date(start_date * 1000);

            let endTime = new Date();
            if (incompletePause) {
              endTime = new Date(incompletePause.start_time * 1000);
            }

            let schedule = working_days ? working_days : "1:2:3:4:5:6:7";
            let scheduleStartTime = starting_time
              ? starting_time.slice(0, 5)
              : "00:00";
            let scheduleEndTime = ending_time
              ? ending_time.slice(0, 5)
              : "23:59";

            let timeSinceAcceptance = getTimeSinceAcceptance(
              startTime,
              endTime,
              scheduleStartTime,
              scheduleEndTime,
              schedule,
              completedPauses,
            );

            duration = timeSinceAcceptance.display;
          }
          if (status == 3) {
            duration = dhm(total_time * 1000);
          }
          tempCsvObj[header] = duration ? duration : NATEXT;
          tempPdfObj[accessor] = duration ? duration : NATEXT;
        } else if (accessor === "secondary_technicians") {
          let asstTechText = NATEXT;
          if (row.secondary_technicians) {
            let namesArr = row.secondary_technicians.split(",");
            asstTechText = namesArr[0];

            if (namesArr?.length > 1) {
              asstTechText += `, +${namesArr.length - 1}`;
            }
          }
          tempCsvObj[header] = asstTechText;
          tempPdfObj[accessor] = asstTechText;
        } else {
          tempCsvObj[header] = row[accessor] ? row[accessor] : NATEXT;

          tempPdfObj[accessor] = row[accessor] ? row[accessor] : NATEXT;
        }
      });

      tempCsvArr.push(tempCsvObj);
      tempPdfArr.push(tempPdfObj);
    });

    //setCsvData(tempCsvArr);
    //setPdfData(tempPdfArr);
    return { csvArr: tempCsvArr, pdfArr: tempPdfArr };
  };

  //Effect to set CSV and PDF Data for work orders
  useEffect(() => {
    if (screen.includes("workorders") && colOrder?.length > 0) {
      (async () => {
        const { csvArr, pdfArr } = await generateWOData();
        setCsvData(csvArr);
        setPdfData(pdfArr);
      })();
    }
  }, [
    colOrder,
    search,
    order,
    start_date,
    end_date,
    start,
    filter_group_id,
    filter_vehicle_id,
  ]);

  const handleExportCsv = async () => {
    if (process.env.REACT_APP_ENV === "prod") {
      // window.gtag("send", "event", `${getScreenName(screen)}_csv`, "Clicked");
      window.gtag("event", `${getScreenName(screen)}_csv`);
    }
    if (tag === "free-user") {
      setSubscribeMsg(t("subscribe_msg"));
      setShowSubscribePopup(true);
      return;
    }

    setLoading(true);
    const data = { ...csvApiData, ...myColumns };
    const csvRes = await getCsvDataV2(data, screen);

    if (csvRes.error) {
      setLoading(false);
      dispatch(addSnackbarData({ msg: t("listing_err_msg"), type: 2 }));
      return;
    }

    setLoading(false);

    window.open(csvRes?.url);
  };

  const handleExportPdf = async () => {
    if (process.env.REACT_APP_ENV === "prod") {
      window.gtag("event", `${getScreenName(screen)}_pdf`);
    }
    if (tag === "free-user") {
      setSubscribeMsg(t("subscribe_msg"));
      setShowSubscribePopup(true);
      return;
    }
    setPdfLoading(true);
    if (
      screenName.includes("users") ||
      //screenName.includes("vehicles") ||
      screenName.includes("workorders") ||
      screenName.includes("dailytimesheet") ||
      screenName.includes("inspectionschedules")
    ) {
      const columns = [];
      const orderLimit = Number(Object.keys(defaultColumns).slice(-1));

      let order = [...colOrder].filter((no) => no <= +orderLimit + 1);

      //Columns in listing is 5 but in pdf, csv is 6 - Hence setting manually
      if (screenName?.includes("inspectionschedules")) {
        order = [1, 2, 3, 4, 5, 6, 7];
      }

      order.forEach((value) => {
        columns.push({
          header: defaultColumns[value - 1].header,
          dataKey: defaultColumns[value - 1].accessor,
        });
      });
      if (screenName.includes("workorders")) {
        (async () => {
          if (pdfData && pdfData?.length > 0) {
            await generatePdfNew(pdfData, columns);
          } else {
            const { pdfArr } = await generateWOData();
            await generatePdfNew(pdfArr, columns);
          }
        })();
      } else {
        await generatePdfNew(pdfData, columns);
      }
    } else {
      const data = { ...csvApiData, ...myColumns };
      const { rows, error } = await getPdfDataV2(data, screen);

      if (error) {
        setPdfLoading(false);
        dispatch(addSnackbarData({ msg: t("listing_err_msg"), type: 2 }));
        return;
      }
      const columns = [];
      const orderLimit = Number(Object.keys(defaultColumns).slice(-1));

      if (screenName === "documentrenewals") {
        let docRenewalRows = [];
        rows.forEach((row) => {
          const { name, document_name, PERCENTAGE, start_date, due_on_date } =
            row;
          //Status
          let status = t("scheduled_caps");
          let color = "#5CB85C";
          if (PERCENTAGE <= 90) {
            status = t("scheduled_caps");
            color = "#5CB85C";
          } else if (PERCENTAGE > 90 && PERCENTAGE < 100) {
            status = t("due_soon_caps");
            color = "#F0AD4E";
          } else if (PERCENTAGE >= 100) {
            status = t("overdue_caps");
            color = "#D9534F";
          }

          // const expiryDate = format(
          //   new Date(due_on_date * 1000),
          //   "yyyy-MM-dd hh:mm:ss"
          // );
          // const lastRenewed = format(
          //   new Date(start_date * 1000),
          //   "yyyy-MM-dd hh:mm:ss"
          // );
          docRenewalRows.push({
            expiry: start_date, //expiryDate,
            last_renewed: due_on_date, //lastRenewed,
            status,
            name,
            document_name,
          });
        });
        const docRenewalCols = [
          { header: t("user"), dataKey: "name" },
          { header: t("doc_name"), dataKey: "document_name" },
          { header: t("status"), dataKey: "status" },
          { header: t("expiry"), dataKey: "expiry" },
          { header: t("last_renewed"), dataKey: "last_renewed" },
        ];
        await generatePdfNew(docRenewalRows, docRenewalCols);
      } else if (
        screenName === "maintenancereminders" ||
        screenName === "renewals"
      ) {
        const typeColName =
          screenName === "maintenancereminders"
            ? t("reminder_type")
            : t("renewal_type");
        const remindersCols = [
          { header: t("asset"), dataKey: "vehicleName" },
          { header: t("task"), dataKey: "taskName" },
          { header: t("status"), dataKey: "status" },
          { header: t("due_in"), dataKey: "dueIn" },
          { header: t("due_on_odo"), dataKey: "dueOnOdo" },
          { header: t("due_on_date"), dataKey: "dueOnDate" },
          { header: t("last_serviced"), dataKey: "lastServiced" },
          { header: typeColName, dataKey: "type" },
        ];
        let reminderRows = [];
        rows.forEach((row) => {
          const { PERCENTAGE } = row;
          const vehicleName = row.NAME;
          const taskName = screen.includes("maintenancereminders")
            ? row.service_task_name
            : row.expense_task_name;
          const distanceUnit =
            row.primary_meter === "Hours"
              ? getDistanceUnit("Hours")
              : getDistanceUnit(distance);
          const lastServicedOdo = +row.last_odo_of_service
            ? `${row.last_odo_of_service} ${distanceUnit}`
            : 0;
          const lastServicedDate = row.last_date_of_service
            ? row.last_date_of_service
            : 0;
          let lastServiced = `${lastServicedOdo} / ${lastServicedDate}`;
          if (lastServicedOdo && !lastServicedDate) {
            lastServiced = lastServicedOdo;
          }

          if (!lastServicedOdo && lastServicedDate) {
            lastServiced = lastServicedDate;
          }

          //dueInDays
          const dueInDays =
            +row["DUE IN"] && +row.due_days
              ? Math.round(Number(row["DUE IN"]))
              : 0;

          //dueInOdo
          const dueInOdo = +row.due_odo
            ? Math.abs(row["MAX ODO"] - row["DUE ODO"])?.toFixed(2)
            : 0;

          //dueInText
          let dueIn = NATEXT;
          if (+row.PERCENTAGE < 100) {
            if (dueInDays && +dueInOdo > 0) {
              dueIn = `${dueInOdo} ${distanceUnit} ${t("or")} ${dueInDays} ${t(
                "days_sm_other",
              )}`;
            } else if (!dueInDays && +dueInOdo > 0) {
              dueIn = `${dueInOdo} ${distanceUnit}`;
            } else if (dueInDays && +dueInOdo <= 0) {
              dueIn = `${dueInDays} ${t("days_sm_other")}`;
            }
          }

          //dueOnDate
          let dueOnDate = NATEXT;
          if (row["DUE DATE"] && +row.due_days > 0) {
            dueOnDate = row["DUE DATE"];
          }

          //dueOnOdo
          let dueOnOdo = NATEXT;
          if (row["DUE ODO"] && +row.due_odo > 0) {
            dueOnOdo = +row["DUE ODO"];
          }

          //Status
          let status = t("scheduled_caps");
          let color = "#5CB85C";
          if (PERCENTAGE <= 90) {
            status = t("scheduled_caps");
            color = "#5CB85C";
          } else if (PERCENTAGE > 90 && PERCENTAGE < 100) {
            status = t("due_soon_caps");
            color = "#F0AD4E";
          } else if (PERCENTAGE >= 100) {
            status = t("overdue_caps");
            color = "#D9534F";
          }

          //Type
          const type =
            row.recurring === "Recurring" ? t("recurring") : t("one_time");

          reminderRows.push({
            vehicleName,
            taskName,
            status,
            dueIn,
            dueOnOdo,
            dueOnDate,
            lastServiced,
            type,
          });
        });

        await generatePdfNew(reminderRows, remindersCols);
      } else if (screenName === "trips") {
        let tripRows = [];
        rows.forEach((row) => {
          const { trip_status } = row;
          //Status
          let status = t("scheduled");
          let color = "#5CB85C";
          if (trip_status === 1) {
            status = t("scheduled");
            color = "#5CB85C";
          } else if (trip_status === 2) {
            status = t("in_progress");

            color = "#F0AD4E";
          } else if (trip_status === 3) {
            status = t("completed");
            color = "#D9534F";
          }
          tripRows.push({ status, ...row });
        });
        colOrder
          .filter((no) => no <= orderLimit + 1)
          .forEach((value) => {
            columns.push({
              header: defaultColumns[value - 1].header,
              dataKey: defaultColumns[value - 1].accessor,
            });
          });
        await generatePdfNew(tripRows, columns);
      } else if (screenName === "vehicles" || screenName === "equipment") {
        let vehicleRows = [];
        rows.forEach((row) => {
          const { veh_active, secondary_status } = row;
          //Vehicle Status
          let vehicleStatus = NATEXT;
          if (veh_active === 1) {
            vehicleStatus = t("active");
          } else {
            vehicleStatus = t("inactive");
          }

          //Operational Status
          let operationalStatus = NATEXT;
          if (veh_active === 1 && secondary_status === 1) {
            operationalStatus = t("out_of_service");
          } else if (veh_active === 0 || veh_active === 2) {
            operationalStatus = NATEXT;
          }

          let currentOdo = NATEXT;

          if (row.odo) {
            let distanceUnit = getDistanceUnit(distance);
            currentOdo = `${row.odo} ${distanceUnit}`;
          }

          vehicleRows.push({
            vehicleStatus,
            operationalStatus,
            currentOdo,
            ...row,
          });
        });
        colOrder
          .filter((no) => no <= orderLimit + 1)
          .forEach((value) => {
            columns.push({
              header:
                value === 1
                  ? screenName === "vehicles"
                    ? t("vehicle")
                    : t("equipment")
                  : defaultColumns[value - 1].header,
              dataKey: defaultColumns[value - 1].accessor,
            });
          });
        await generatePdfNew(vehicleRows, columns);
      } else if (screenName === "issues") {
        let issueRows = [];
        rows.forEach((row) => {
          const {
            veh_active,
            secondary_status,
            time_to_close,
            status,
            priority,
          } = row;

          //Issue Status
          let issueStatus = NATEXT;
          if (status === "new") {
            issueStatus = t("new");
          } else if (status == 0) {
            issueStatus = t("drawer_open");
          } else if (status == 1) {
            issueStatus = t("in_progress");
          } else if (status == 2) {
            issueStatus = t("closed");
          }

          //Issue Priority
          let issuePriority = t("not_set");
          if (priority === 1) {
            issuePriority = t("low");
          } else if (priority === 2) {
            issuePriority = t("med");
          } else if (priority === 3) {
            issuePriority = t("high");
          }

          //vehicle secondary status
          let vehicleStatus = t("in_service");

          if (veh_active === 1 && secondary_status === 1) {
            vehicleStatus = t("out_of_service");
          }

          if (veh_active === 0 || veh_active === 2) {
            vehicleStatus = NATEXT;
          }

          //time to close
          let timeToClose = NATEXT;
          if (time_to_close && Number(time_to_close) > 0) {
            timeToClose = daysHoursMinutes(Number(time_to_close)).display;
          }

          issueRows.push({
            issueStatus,
            issuePriority,
            vehicleStatus,
            timeToClose,
            ...row,
          });
        });
        colOrder
          .filter((no) => no <= orderLimit + 1)
          .forEach((value) => {
            columns.push({
              header: defaultColumns[value - 1].header,
              dataKey: defaultColumns[value - 1].accessor,
            });
          });
        await generatePdfNew(issueRows, columns);
      } else {
        colOrder
          .filter((no) => no <= orderLimit + 1)
          .forEach((value) => {
            columns.push({
              header: defaultColumns[value - 1].header,
              dataKey: defaultColumns[value - 1].accessor,
            });
          });
        await generatePdfNew(rows, columns);
      }
    }
  };

  // Function to load Arabic font dynamically
  const loadArabicFont = async () => {
    if (direction === "rtl") {
      try {
        // Dynamically import the Arabic font from src directory
        await import("../../../../../fonts/Amiri-Regular.js");
        console.log("Arabic font loaded successfully");
        return true;
      } catch (error) {
        console.warn("Failed to load Arabic font:", error);
        return false;
      }
    }
    return true;
  };

  const generatePdfNew = async (rows, columns) => {
    // Load Arabic font if needed
    await loadArabicFont();

    let pdfsize = "a0";
    if (columns.length > 11) {
      pdfsize = "a2";
    }
    if (columns.length >= 7 && columns.length <= 11) {
      pdfsize = "a3";
    }
    if (columns.length < 7) {
      pdfsize = "a4";
    }

    const dataKeyArr = columns.map((col) => col?.dataKey);

    // if (
    //   dataKeyArr?.includes("service_task_name") ||
    //   dataKeyArr?.includes("expense_task_name")
    // ) {
    //   pdfsize = "a3";
    // }
    let colStyles = {};
    columns.forEach((col, i) => {
      colStyles[i] = {
        cellWidth: "auto",
        minCellWidth: 100,
        // Add RTL support for Arabic columns
        halign: direction === "rtl" ? "right" : "left",
        font: direction === "rtl" ? "Amiri-Regular" : "helvetica",
      };
    });

    const doc = new jsPDF("l", "pt", pdfsize);

    // Set Arabic font if language is Arabic
    if (direction === "rtl") {
      try {
        doc.setFont("Amiri-Regular", "normal");
      } catch (error) {
        console.warn("Failed to set Arabic font, using helvetica:", error);
        doc.setFont("helvetica", "normal");
      }
    } else {
      doc.setFont("helvetica", "normal");
    }
    doc.setDisplayMode("original", "continuous", "UseOutlines");

    // Set text direction for headers and content
    const textAlign = direction === "rtl" ? "right" : "left";

    // Adjust Y positions for Arabic text to prevent cutting off
    //const headerY = direction === "rtl" ? 120 : 40;
    //const subHeaderY = direction === "rtl" ? 150 : 70;
    //const tableStartY = direction === "rtl" ? 180 : 100;

    // Set appropriate font size for Arabic text
    const headerFontSize = direction === "rtl" ? 14 : 12;
    const subHeaderFontSize = direction === "rtl" ? 12 : 11;

    doc.setFontSize(headerFontSize);

    // Use different positioning for Arabic text
    // if (direction === "rtl") {
    //   // For Arabic, use simple positioning to prevent cutting
    //   console.log(`Drawing header "${pdfHeader}" at Y: ${headerY}`);
    //   doc.text(pdfHeader, doc.internal.pageSize.width - 40, 40, { align: textAlign });
    //   doc.setFontSize(subHeaderFontSize);
    //   const text = t("report_gen_by_pdf_text", { userName });
    //   console.log(`Drawing subheader "${text}" at Y: ${subHeaderY}`);
    //   doc.text(text, doc.internal.pageSize.width - 40, 70, { align: textAlign });
    // } else {
    doc.text(
      pdfHeader,
      direction === "rtl" ? doc.internal.pageSize.width - 40 : 40,
      40,
      { align: textAlign },
    );
    doc.setFontSize(subHeaderFontSize);
    const text = t("report_gen_by_pdf_text", { userName });
    doc.text(
      text,
      direction === "rtl" ? doc.internal.pageSize.width - 40 : 40,
      70,
      { align: textAlign },
    );
    // }
    autoTable(doc, {
      //tableWidth: 200,
      startY: 100,
      theme: "grid",

      styles: {
        font: direction === "rtl" ? "Amiri-Regular" : "helvetica",
        fontSize: 10,
      },

      bodyStyles: {
        valign: "top",
        halign: direction === "rtl" ? "right" : "left",
        font: direction === "rtl" ? "Amiri-Regular" : "helvetica",
      },
      //styles: {
      //minCellWidth: 100,
      //overflow: "ellipsize",
      //cellWidth: "auto",
      //font: "MyFont",
      //},
      columnStyles: colStyles,

      headStyles: {
        fillColor: "#2D4154",
        height: "100px",
        halign: direction === "rtl" ? "right" : "left",
        font: direction === "rtl" ? "Amiri-Regular" : "helvetica",
        fontSize: 10,
      },
      body: rows,
      columns: columns,
      didDrawPage: function () {
        var str = `${t("created_on")}: ` + Date();
        doc.text(
          str,
          direction === "rtl" ? doc.internal.pageSize.width - 40 : 40,
          doc.internal.pageSize.height - 10,
          { align: textAlign },
        );
      },
    });
    doc.save(`sf_${pdfFileName}_${new Date().toISOString().split("T")[0]}`);
    setPdfLoading(false);
  };

  const handleImport = () => {
    if (process.env.REACT_APP_ENV === "prod") {
      // window.gtag(
      //   "send",
      //   "event",
      //   `${getScreenName(screen)}_import`,
      //   "Clicked"
      // );
      window.gtag("event", `${getScreenName(screen)}_import`);
    }
    if (tag === "free-user") {
      setSubscribeMsg(t("subscribe_msg"));
      setShowSubscribePopup(true);
      return;
    }

    if (tag === "essential-user" && screen?.includes("parts")) {
      setSubscribeMsg(t("subscribe_to_advanced_msg"));
      setShowSubscribePopup(true);
      return;
    }
    setImportScreenName(moduleName);
    setShowImportPopup(true);

    setToggleOptions(false);
    // setImportData({
    //   show: true,

    //   data: { modalHeading: "Import Daily Mileage into Simply Fleet" },
    // });
  };

  const handleImportPartBatches = () => {
    if (process.env.REACT_APP_ENV === "prod") {
      window.gtag("event", `batches_import`);
    }
    if (tag === "free-user") {
      setSubscribeMsg(t("subscribe_msg"));
      setShowSubscribePopup(true);
      return;
    }

    if (tag === "essential-user" && screen?.includes("parts")) {
      setSubscribeMsg(t("subscribe_to_advanced_msg"));
      setShowSubscribePopup(true);
      return;
    }
    setImportScreenName("partBatches");
    setShowImportPopup(true);

    setToggleOptions(false);
  };

  const handleTelematicsVehicleSync = async () => {
    if (tag === "free-user") {
      setSubscribeMsg(t("free_user_telematics_msg"));
      setShowSubscribePopup(true);
      return;
    }

    // if (tag === "essential-user") {
    //   setSubscribeMsg(t("subscribe_to_advanced_msg"));
    //   setShowSubscribePopup(true);
    //   return;
    // }

    setNewVehiclesLoading(true);

    const subRes = await postApi(
      {
        querystring: "get_subscription_status",
      },
      "subscription",
    );
    if (subRes.success) {
      console.log("subRes", subRes);
      const { success, ...subscription_data } = subRes;
      const { telematics_stripe_status } = subscription_data;
      if (telematics_stripe_status !== "active") {
        setNewVehiclesLoading(false);
        setSubscribeMsg(t("paid_user_telematics_msg"));
        setShowSubscribePopup(true);
        return;
      }
    }

    const apiData = {
      querystring: "fetch_new_vehicles",
      primary_meter: distance,
      showExistingVehicles: 0,
      //api_token: apiToken,
      //fetch_all_vehicles: fetchAllEntities.allVehicles ? 1 : 0,
      //fetch_all_users: fetchAllEntities.allUsers ? 1 : 0,
      //provider: 1,
      //provider_type: 1,
    };
    console.log(apiData);
    const res = await post("integrations", apiData);
    setNewVehiclesLoading(false);
    console.log("res", res);
    if (res.success) {
      const { data } = res;
      if (data?.length > 0) {
        console.log("data", data);
        const vehiclesToImport = data.map((d) => ({ ...d, isChecked: true }));
        setVehicles(vehiclesToImport);
        setShowImportVehiclesPopup(true);
      }
    } else {
      if (res.message === "no_new_vehicles") {
        dispatch(
          addSnackbarData({
            msg: t("no_new_vehicles_found_msg", { providerName }),
            type: 2,
          }),
        );
      } else {
        dispatch(
          addSnackbarData({
            msg: t("listing_err_msg"),
            type: 2,
          }),
        );
      }
    }
    setToggleOptions(false);
  };

  return (
    <>
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={subscribeMsg}
        />
      )}
      {showNewVehiclesAddedPopup && (
        <InfoPopup
          showPopup={showNewVehiclesAddedPopup}
          setShowPopup={setShowNewVehiclesAddedPopup}
          message={newVehiclesAddedData.message}
          icon={newVehiclesAddedData.icon}
        />
      )}
      {/* {showImportPopup && (
        <ImportComponent
          showPopup={showImportPopup}
          setShowPopup={setShowImportPopup}
          modalHeading={'Import Daily Mileage into Simply Fleet'}
        />
      )} */}
      <OptionsMenuWrap id="more-options">
        {modulesForCsvPdf.includes(moduleName) && (
          <>
            <OptionsMenu
              onClick={async () => await handleExportPdf()}
              id="export-pdf-button"
            >
              {pdfLoading ? (
                <div style={{ width: 100 }}>
                  <Loading loading={true} />
                </div>
              ) : (
                <>
                  <span>{t("export_pdf")}</span>
                  {tag === "free-user" && (
                    <SubscribeTooltipIcon message={t("subscribe_msg")} />
                  )}
                </>
              )}
            </OptionsMenu>
            {!screen.includes("users") &&
              //!screen.includes("vehicles") &&
              !screen.includes("workorders") &&
              !screen.includes("dailytimesheet") &&
              !screen.includes("inspectionscheduling") && (
                <OptionsMenu
                  onClick={async () => await handleExportCsv()}
                  id="export-csv-button"
                >
                  {loading ? (
                    <div style={{ width: 100 }}>
                      <Loading loading={true} />
                    </div>
                  ) : (
                    <>
                      <span>{t("export_csv")}</span>
                      {tag === "free-user" && (
                        <div className="d-flex justify-content-end">
                          <SubscribeTooltipIcon message={t("subscribe_msg")} />
                        </div>
                      )}
                    </>
                  )}
                </OptionsMenu>
              )}
            {(screen.includes("users") ||
              //screen.includes("vehicles") ||
              screen.includes("workorders") ||
              screen.includes("dailytimesheet") ||
              screen.includes("inspectionscheduling")) && (
              <CSVLink
                data={csvData}
                filename={`sf_${pdfFileName}_${
                  new Date().toISOString().split("T")[0]
                }`}
                //onClick={() => setLoading(true)}
                //onLoadedData={() => setLoading(false)}
              >
                <OptionsMenu
                  // onClick={() => {
                  //   // if (process.env.ENV === "prod") {
                  //   window.gtag(
                  //     "send",
                  //     "event",
                  //     `${getScreenName(screen)}_csv`,
                  //     "Clicked"
                  //   );
                  //   // }
                  // }}
                  //onClick={async () => await handleExportCsv()}
                  onClick={(e) => {
                    if (process.env.REACT_APP_ENV === "prod") {
                      // window.gtag(
                      //   "send",
                      //   "event",
                      //   `${getScreenName(screen)}_csv`,
                      //   "Clicked"
                      // );
                      window.gtag("event", `${getScreenName(screen)}_csv`);
                    }
                    if (tag === "free-user") {
                      e.preventDefault();
                      setSubscribeMsg(t("subscribe_msg"));
                      setShowSubscribePopup(true);
                      return;
                    }
                  }}
                  id="export-csv-button"
                >
                  {loading ? (
                    <Loading loading={true} />
                  ) : (
                    <>
                      <span>{t("export_csv")} </span>
                      {tag === "free-user" && (
                        <SubscribeTooltipIcon message={t("subscribe_msg")} />
                      )}
                    </>
                  )}
                </OptionsMenu>
              </CSVLink>
            )}
          </>
        )}
        {modulesForImport.includes(moduleName) &&
          roleId != 4 &&
          !isViewOnly && (
            <>
              <OptionsMenu id="import-button" onClick={handleImport}>
                <span>
                  {moduleName === "parts" ? t("import_parts") : t("import")}
                </span>
                {tag === "free-user" && (
                  <SubscribeTooltipIcon message={t("subscribe_msg")} />
                )}
                {tag === "essential-user" && screen?.includes("parts") && (
                  <SubscribeTooltipIcon
                    message={t("subscribe_to_advanced_msg")}
                  />
                )}
              </OptionsMenu>
              {moduleName === "parts" && (
                <OptionsMenu
                  id="import-part-batches-button"
                  onClick={handleImportPartBatches}
                >
                  <span>{t("import_batches")}</span>
                  {tag === "free-user" && (
                    <SubscribeTooltipIcon message={t("subscribe_msg")} />
                  )}
                  {tag === "essential-user" && screen?.includes("parts") && (
                    <SubscribeTooltipIcon
                      message={t("subscribe_to_advanced_msg")}
                    />
                  )}
                </OptionsMenu>
              )}
            </>
          )}
        {screen?.includes("vehicles") &&
          integrationsPresent &&
          roleId === 1 &&
          !jimilabUser && (
            <OptionsMenu
              id="telematics-veh-sync-button"
              onClick={handleTelematicsVehicleSync}
            >
              {newVehiclesLoading ? (
                <div style={{ width: "165px" }}>
                  <Loading loading={true} />
                </div>
              ) : (
                <>
                  <span>{t("sync_telematics_veh")}</span>
                  {tag === "free-user" && (
                    <SubscribeTooltipIcon
                      message={t("free_user_telematics_msg")}
                    />
                  )}
                  {/* {tag === "essential-user" && (
                    <SubscribeTooltipIcon
                      message={t("subscribe_to_advanced_msg")}
                    />
                  )} */}
                </>
              )}
              {/* <span>
                {newVehiclesLoading ? (
                  <div className="w-100 d-flex align-items-center">
                    <Loading loading={true} />
                  </div>
                ) : (
                  t("sync_telematics_veh")
                )}
              </span> */}
            </OptionsMenu>
          )}
      </OptionsMenuWrap>
    </>
  );
};

const Loading = () => {
  return (
    <LoaderWrap>
      <Loader>
        <path fill={colorBlue} d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
      </Loader>
    </LoaderWrap>
  );
};

// styles

export const OptionsMenuWrap = styled.div`
  z-index: 100;
  position: absolute;
  min-width: 120px;
  padding: 0;
  //top: 125px;
  ${right}: 24px;
  border: 1px solid lightgray;
  background: white;

  @media screen and (max-width: 320px) {
    ${right}: -50px;
  }
`;

export const OptionsMenu = styled.span`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  white-space: nowrap;
  padding: 8px;
  margin-top: 0;
  background: ${colorBackground};
  color: ${colorTextNew};

  &:hover {
    color: ${colorBlue};
  }

  button {
    padding: 0;

    &:hover {
      background-color: ${colorHover};
    }
  }

  *:focus {
    outline: none;
  }

  @media screen and (min-width: 480px) {
    width: 100%;
    ${left}: 0 !important;
  }
`;

export const MoreOptionsButtonContainer = styled(Button)`
  ${marginRight}: 0px;
  padding: 4px 8px;
  height: 35px;

  @media screen and (max-width: 480px) {
    ${marginRight}: 0;
  }
`;

const Loader = styled.svg`
  animation: linear load 2s infinite;
  margin: auto;
  width: 26px;
  height: 26px;

  @keyframes load {
    from {
      transform: rotate(0deg) scale(0.75);
    }
    to {
      transform: rotate(360deg) scale(0.75);
    }
  }
`;

export const LoaderWrap = styled.div`
  display: flex;
  justify-content: start;
  align-items: start;
  width: auto;
  height: auto;
`;
